import styled from "styled-components"

const AccesDirectItemContainer = styled.div`
  &:hover {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
  border: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
`

export { AccesDirectItemContainer }
